export default "__VITE_ASSET__Nvyl7kla__"